export enum GradientStripType {
  VERY_GREEN = 'VERY_GREEN',
  GREEN = 'GREEN',
  ORANGE = 'ORANGE',
  RED = 'RED'
}

export interface GradientStripConfig {
  gradientColor: string
  textColor: string
}

const gradientConfigMap: Record<GradientStripType, GradientStripConfig> = {
  [GradientStripType.VERY_GREEN]: {
    gradientColor: '#7AEB9A',
    textColor: '#00661D'
  },
  [GradientStripType.GREEN]: {
    gradientColor: '#E4FCEB',
    textColor: '#00661D'
  },
  [GradientStripType.ORANGE]: {
    gradientColor: '#FFF4E6',
    textColor: '#CC5C2D'
  },
  [GradientStripType.RED]: {
    gradientColor: '#FFEDE9',
    textColor: '#CC5C2D'
  }
}

interface GradientStripProps {
  type?: GradientStripType
  gradientColor?: string
  textColor?: string
  children: React.ReactNode
  className?: string
}

export const GradientStrip = ({
  type,
  gradientColor: overrideGradientColor,
  textColor: overrideTextColor,
  children,
  className = ''
}: GradientStripProps) => {
  let config: GradientStripConfig

  // Priority: override props > type > default
  if (overrideGradientColor && overrideTextColor) {
    config = {
      gradientColor: overrideGradientColor,
      textColor: overrideTextColor
    }
  } else if (type) {
    config = gradientConfigMap[type]
  } else {
    config = gradientConfigMap[GradientStripType.GREEN]
  }

  // Allow partial overrides
  const finalGradientColor = overrideGradientColor || config.gradientColor
  const finalTextColor = overrideTextColor || config.textColor

  return (
    <div
      className={`p-4 rounded-xl bg-gradient-to-r from-[${finalGradientColor}] to-transparent ${className}`}
      style={{
        background: `linear-gradient(to right, ${finalGradientColor}, transparent)`
      }}
    >
      <div style={{ color: finalTextColor }}>{children}</div>
    </div>
  )
}
